import * as React from 'react'
import type {SVGProps} from 'react'
const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={15} viewBox="0 0 25 25" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M19.7,1.2h3.8l-8.4,9.6,9.9,13h-7.7l-6-7.9-6.9,7.9H.5l9-10.2L0,1.2h7.9l5.5,7.2s6.3-7.2,6.3-7.2ZM18.3,21.5h2.1L6.8,3.4h-2.3l13.8,18.1Z"
        />
    </svg>
)
export default SvgTwitter
